import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data.map(d => {
      let description =
        d.provider === 'payabli' && d.description
          ? JSON.parse(d.description)
          : {}
      if ('token' in description) {
        description['token'] = atob(description['token'])
      }
      return {
        ...d,
        description,
        greyfinch_pay_app_enabled:
          d.location?.feature_flags?.is_pay_app_enabled &&
          d.provider === 'payabli',
        fee_mode: d.fee_mode,
        card_fee_percent: d.card_fee_percent,
        ach_fee_percent: d.ach_fee_percent,
        has_changes: false,
        is_fee_acknowledged: d.fee_acknowledged_by_user_id !== null,
        is_fee_acknowledged_original: d.fee_acknowledged_by_user_id !== null,
      }
    })
  }, [data])
}
